export function cleanText(value: unknown): string | null {
  if (typeof value !== 'string') return null
  const cleaned = value.trim()
  return cleaned || null
}

export function phoneNumber(value: unknown): string | null {
  const cleaned = cleanText(value)
  if (!cleaned) return null
  const compact = cleaned.replace(/[\s().-]/g, '')
  return /^\+?[1-9]\d{6,14}$/.test(compact) ? cleaned : null
}

export function emailAddress(value: unknown): string | null {
  const cleaned = cleanText(value)
  if (!cleaned || /\s/.test(cleaned)) return null
  return /^[^@]+@[^@]+\.[^@]+$/.test(cleaned) ? cleaned : null
}

export function isPhoneValuedName(value: string): boolean {
  return phoneNumber(value) !== null
}
